export default {
    loyalty:{
        subscription:'Абонемент',
        CreateSubscription: 'Создать абонемент',
        subscriptionType:'Тип Абонемента',
        name:'Название',
        type:'Тип',
        price: 'Стоимость',
        validity:'Срок действия (месяцев)',
        faceValue: 'Номинал',
        membership_freezing:'Допускается ли заморозка абонементов',
        membership_freezing_period: 'Максимальный общий период заморозки',
        Service_category:'Категории услуг',
        Service: 'Услуга',
        quantity:'Количество',
        online_pay_relevance:'Доступность для онлайн продажи',
        total_cost: 'Итоговая сумма'
    }
}